export default class Forms {
  constructor() {
    this.initSelects();
    this.initSubmits();
    this.newsletter();
  }

  initSelects() {
    const selects = document.querySelectorAll(".wpcf7-select");
    selects.forEach((element) => {
      const placeholder = $(element).closest("label").data("placeholder");
      $(element).find("option:first").text(placeholder);
      // .prop('disabled', true)
    });
  }

  initSubmits() {
    const submits = $(".wpcf7-submit");
    $(submits).each((key, value) => {
      $(
        `<button type="submit"><span>${value.value}</span></button>`
      ).insertAfter(value);
    });
  }

  newsletter() {
    const form = $("#newsletter");
    const input = $("#newsletter-input");
    $(form).on("submit", (e) => {
      e.preventDefault();
      $.ajax({
        url: "https://czechybiznes.expert/newsletter/add",
        method: "POST",
        dataType: "json",
        crossDomain: true,
        data: {
          action: "addEmail",
          email: input.val(),
        },
        success: function (response) {
          console.log(response);
        },
        error: function (error) {
          console.error(error);
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/forms.js